import './App.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import EmailList from './emails/email-list';
import CreateTemplate from './emails/create-email';
import { useLocation } from 'react-router-dom';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import { Box, ChakraProvider, Flex, Text, Image } from '@chakra-ui/react';

// Updated Nav component using Chakra UI elements
function Nav() {
  const location = useLocation();
  const isCreate = location?.pathname === '/create' || location?.pathname === '/edit';

  return (
    <Flex as="nav" bg="teal.600" px={6} py={4} color="white" justify={isCreate ? 'flex-start' : 'center'} align="center" boxShadow="md">
      <Image src={`${process.env.PUBLIC_URL || ''}/favicon.svg`} alt="Templato" boxSize="28px" mr={3} display={isCreate ? 'block' : 'none'} />
      <Text fontSize="xl" fontWeight="bold" letterSpacing="tight">
        Build your email template
      </Text>
    </Flex>
  );
}

function App() {
  const basename = process.env.PUBLIC_URL ? new URL(process.env.PUBLIC_URL, window.location.origin).pathname.replace(/\/$/, '') : '';

  return (
    <ChakraProvider>
      <Box>
        {/* Nav component always visible */}
        <Router basename={basename}>
          <Nav />

          {/* Routes control the content below the nav */}
          <Box className='content' p={4}>
            <Routes>
              <Route path='/' element={<EmailList />} />

              {/* Wrap CreateTemplate in DndProvider */}
              <Route
                path='/create'
                element={
                  <DndProvider backend={HTML5Backend}>
                    <CreateTemplate />
                  </DndProvider>
                }
              />

              {/* Edit route for imported templates */}
              <Route
                path='/edit'
                element={
                  <DndProvider backend={HTML5Backend}>
                    <CreateTemplate />
                  </DndProvider>
                }
              />
            </Routes>
          </Box>
        </Router>
      </Box>
    </ChakraProvider>
  );
}

export default App;
